import type { IFilterableListItem, IOmit, ISelectProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { Field, Select, Skeleton } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { getPollInfo } from '~/components/molecules/PollListItem/getPollInfo';
import { usePollsQuery } from '~/lib/api/modules/Polls/hooks/usePollsQuery';

export type IPollSelectorProps = IOmit<ISelectProps, 'items'> & {
  appId: string;
};

export const PollSelector = forwardRef<HTMLInputElement, IPollSelectorProps>(
  function PollSelector(props, forwardedRef) {
    const { appId, ...other } = props;
    const pollsQuery = usePollsQuery({ appId });
    const { t } = useTranslation();
    const items: Array<IFilterableListItem> =
      pollsQuery.data?.list.map((poll) => {
        const pollInfo = getPollInfo(poll);

        return {
          value: poll._id,
          label: poll.title,
          trailingSupportingText: t(`PollInfo.${pollInfo.status}`),
        };
      }) ?? [];

    return pollsQuery.isError ? (
      <ErrorMessage error={pollsQuery.error} />
    ) : !!pollsQuery.data || !pollsQuery.isLoading ? (
      <Select
        {...other}
        items={items}
        ref={forwardedRef}
        disabled={pollsQuery.isLoading}
      />
    ) : (
      <Skeleton>
        <Field />
      </Skeleton>
    );
  },
);
